import React, { useEffect, useState } from "react";
import { Badge, Row } from "react-bootstrap";
import { withNamespaces } from "react-i18next";

const ExportFilter = ({ t, callBack }) => {
  const [variantToday, setVariantToday] = useState("light");
  const [variantThisWeek, setVariantThisWeek] = useState("light");
  const [variantThisMonth, setVariantThisMonth] = useState("light");
  const [variantAll, setVariantAll] = useState("secondary");
  const [variantNew, setVariantNew] = useState("light");

  useEffect(() => {}, [
    variantToday,
    variantThisWeek,
    variantThisMonth,
    variantAll,
  ]);

  useEffect(() => {
    dataToParent("all");
  }, []);

  const dataToParent = (data) => {
    callBack(data);
  };

  /**Styles */
  const badgeStyle = {
    cursor: "pointer",
    height: "100%",
    display: "flex",
    width: "50%",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
  };

  const unselectBadges = () => {
    if (variantToday === "secondary") {
      setVariantToday("light");
    }
    if (variantThisWeek === "secondary") {
      setVariantThisWeek("light");
    }
    if (variantThisMonth === "secondary") {
      setVariantThisMonth("light");
    }
    if (variantAll === "secondary") {
      setVariantAll("light");
    }
    if (variantNew === "secondary") {
      setVariantNew("light");
    }
  };

  const selectToday = () => {
    setVariantToday("secondary");
    dataToParent("today");
  };

  const selectThisWeek = () => {
    setVariantThisWeek("secondary");
    dataToParent("week");
  };

  const selectThisMonth = () => {
    setVariantThisMonth("secondary");
    dataToParent("month");
  };

  const selectAll = () => {
    setVariantAll("secondary");
    dataToParent("all");
  };

  const selectNew = () => {
    setVariantNew("secondary");
    dataToParent("new");
  };

  const isMobile = window.innerWidth < 992 ? true : false;

  return (
    <div style={{ paddingBottom: "5px", marginBottom: "10px" }}>
      <Row
        style={
          isMobile
            ? {
                display: "flex",
                flexWrap: "nowrap",
                margin: "0px",
                height: "30px",
                fontSize: "12px",
              }
            : {
                display: "flex",
                flexWrap: "nowrap",
                margin: "0px",
                height: "30px",
              }
        }
      >
        <Badge
          variant={variantToday}
          style={{ ...badgeStyle, marginRight: "5px" }}
          onClick={() => {
            unselectBadges();
            selectToday();
          }}
        >
          {t("datacapture.general.today")}
        </Badge>
        <Badge
          variant={variantThisWeek}
          style={{ ...badgeStyle, marginRight: "5px" }}
          onClick={() => {
            unselectBadges();
            selectThisWeek();
          }}
        >
          {t("datacapture.general.thisWeek")}
        </Badge>

        <Badge
          variant={variantThisMonth}
          style={{ ...badgeStyle, marginRight: "5px" }}
          onClick={() => {
            unselectBadges();
            selectThisMonth();
          }}
        >
          {t("datacapture.general.thisMonth")}
        </Badge>
        <Badge
          variant={variantAll}
          style={{ ...badgeStyle, marginRight: "5px" }}
          onClick={() => {
            unselectBadges();
            selectAll();
          }}
        >
          {t("datacapture.general.all")}
        </Badge>
        <Badge
          variant={variantNew}
          style={{ ...badgeStyle, marginRight: "5px" }}
          onClick={() => {
            unselectBadges();
            selectNew();
          }}
        >
          New
        </Badge>
      </Row>
    </div>
  );
};

export default withNamespaces()(ExportFilter);
